import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import ContractsAnalytics from '@/components/contracts/ContractsAnalytics';
import ContractsRecords from '@/components/contracts/ContractsRecords';
import CreateContractWizard from '@/components/contracts/create/CreateContractWizard';
import { MonthRangePicker } from '@/components/MonthRangePicker';
import { endOfMonth } from 'date-fns';
import { businessToday } from '@/lib/format';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Contracts() {
  const navigate = useNavigate();
  const [monthRange, setMonthRange] = useState({
    from: new Date(2020, 0, 1),
    to: endOfMonth(businessToday()),
  });
  const [wizardOpen, setWizardOpen] = useState(false);

  const handleContractCreated = (contractId: number) => {
    navigate(`/dashboard/contracts/${contractId}`);
  };

  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="mb-8 flex items-start justify-between">
        <div>
          <h1 className="text-4xl font-semibold tracking-tight mb-2">Contracts</h1>
          <p className="text-muted-foreground">Track and manage vehicle rental contracts.</p>
        </div>
        <Button onClick={() => setWizardOpen(true)}>
          <Plus className="h-4 w-4 mr-2" />
          New Contract
        </Button>
      </div>

      <Tabs defaultValue="summary" className="space-y-4">
        <div className="flex items-center justify-between">
          <TabsList>
            <TabsTrigger value="summary">Summary</TabsTrigger>
            <TabsTrigger value="records">Records</TabsTrigger>
          </TabsList>
          <MonthRangePicker monthRange={monthRange} onMonthRangeChange={setMonthRange} />
        </div>

        <TabsContent value="summary">
          <ContractsAnalytics monthRange={monthRange} />
        </TabsContent>

        <TabsContent value="records">
          <ContractsRecords monthRange={monthRange} />
        </TabsContent>
      </Tabs>

      <CreateContractWizard
        open={wizardOpen}
        onOpenChange={setWizardOpen}
        onSuccess={handleContractCreated}
      />
    </div>
  );
}
